import { BaseAction } from "../../../core/actions/BaseAction";
import { IBookedOfferSummary, IBookingSearchResult } from "../../../Orchestrator/Types/Index";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import dayjs from "dayjs"

class GetBookingIsPastOrUpcoming extends BaseAction<IDefaultActionResult, IBookingSearchResult> {
    override async run(): Promise<IDefaultActionResult> {
        let actionResult: IDefaultActionResult = {
            data: false,
            message: "",
            status: "fail"
        }
        try {
            if (this.params!) {                
                const result: IBookingSearchResult = this.params;
                const allBookedOfferSummariesWithoutExchange: IBookedOfferSummary[] = result.bookedOfferSummaries.filter(summary => {
                    const filterPartSummariesWithoutExchange = summary.bookingPartSummaries.find(summary => summary.status === "EXCHANGED")
                    return filterPartSummariesWithoutExchange ? false : true
                })
                const allTripSummariesWithoutExchange = result.tripSummaries.filter(summary => {
                    return allBookedOfferSummariesWithoutExchange.map(d => d.tripRef).includes(summary.id)
                })

                let isPastBooking = false
                if (allTripSummariesWithoutExchange.length > 0) {
                    if (allTripSummariesWithoutExchange.length == 2) {
                        const outboundPast = dayjs(allTripSummariesWithoutExchange[0].startTime).isBefore(dayjs()) || false
                        const inboundPast = dayjs(allTripSummariesWithoutExchange[1].startTime).isBefore(dayjs()) || false
                        isPastBooking = (outboundPast && inboundPast)
                    } else {
                        const outboundPast = dayjs(allTripSummariesWithoutExchange[0].startTime).isBefore(dayjs()) || false
                        isPastBooking = outboundPast
                    }
                }
                actionResult.data = isPastBooking
            }
        } catch (error) {
            actionResult.message = "Something went wrong"
        } finally {
            return actionResult
        }
    }
}
export const getBookingIsPastOrUpcoming = new GetBookingIsPastOrUpcoming()


